import React from 'react';
import PropTypes from 'prop-types';
import { useFela } from 'react-fela';

const rule = ({ right, theme }) => ({
  opacity: right ? theme.opacity.enabled : theme.opacity.hovered,
  color: 'white',
});

const Time = ({ right, ...otherProps }) => {
  const { css } = useFela({ right });

  return (
    <time className={css(rule)} {...otherProps} />
  );
};

Time.propTypes = {
  right: PropTypes.bool,
};

export default React.memo(Time);
